<template>
  <div class="pa-2">
    <h4 class="settings-h4">
      {{ computedTitle }}Mail Gateway
    </h4>

    <div class="wrapper-2 pa-4 mb-4 pos-relative">
      <div class="d-flex align-center">
        <!--DISABLE / ENABLE -->
        <v-tooltip right :open-on-hover="organization.status === 0">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-simple-checkbox
                class="d-inline mr-2"
                v-model="isSettingsEnabled"
                :disabled="organization.status !== 0"
              ></v-simple-checkbox>
            </span>
          </template>
          <span>{{ isSettingsEnabled ? 'Disable' : 'Enable' }} updating</span>
        </v-tooltip>

        <InputsSenderVendor
          :organization="organization"
          :isSettingsEnabled="isSettingsEnabled"
          :backupType="backupType"
          :actionType="actionType"
          :isGlobalSettings="isGlobalSettings"
        />
      </div>

      <!--IF THE CONNECTION IS SMTP-->
      <SMTP
        v-if="computedIsShowSMTP"
        :organization="organization"
        :backupType="backupType"
        :isSettingsEnabled="isSettingsEnabled"
      />

      <!--IF THE CONNEECTION IS GRAPH-->
      <MsGraph
        v-if="computedIsShowMsGraph"
        :organization="organization"
        :isSettingsEnabled="isSettingsEnabled"
        :backupType="backupType"
        class="mb-3"
      />

      <!--IF THIS IS SUPER ADMIN-->
      <div v-if="isShowSuperAdminEmailMesssage" class="mb-2">
        Super admin cannot see the host's custom email settings.
      </div>

      <!-- EMAIL TESTING -->
      <TestEmail
        v-if="computedIsShowTestEmail"
        :organization="organization"
        :isSettingsEnabled="isSettingsEnabled"
        :backupType="backupType"
        :setIsCheckSmtpChange="setIsCheckSmtpChange"
        :setIsCheckBackupSmtpChange="setIsCheckBackupSmtpChange"
        :setIsCheckSecondBackupSmtpChange="setIsCheckSecondBackupSmtpChange"
        class="mb-6"
      />
      <OnlineHelp
        :page="isGlobalSettings ? 'globalSettings' : 'settings'"
        :section="backupType === 0 ? 'SMTPSettings' : backupType === 1 ? 'backupSMTPSettings' : 'secondaryBackupSMTPSettings'"
        :title="backupType === 0 ? 'Mail Gateway' : backupType === 1 ? 'Backup Mail Gateway' : 'Secondary Backup Mail Gateway'"
      />
    </div>
  </div>
</template>

<script>
import OnlineHelp from '@/components/BaseComponents/OnlineHelp/OnlineHelp.vue'
import { mapGetters } from 'vuex'
import TestEmail from '../TestEmail/TestEmail.vue'

//Childrens
import InputsSenderVendor from './Childrens/InputsSenderVendor/InputsSenderVendor.vue'
import MsGraph from './Childrens/MsGraph/MsGraph.vue'
import SMTP from './Childrens/SMTP/SMTP.vue'

export default {
  name: 'EmailSettings',
  data() {
    return {
      isSettingsEnabled: false,
    }
  },
  props: {
    organization: Object,
    actionType: String,
    backupType: Number,
    setIsCheckSmtpChange: Function,
    setIsCheckBackupSmtpChange: Function,
    setIsCheckSecondBackupSmtpChange: Function,
    isGlobalSettings: {
      type: Boolean,
      default: false,
    },
  },

  components: { InputsSenderVendor, SMTP, MsGraph, TestEmail, OnlineHelp },

  computed: {
    ...mapGetters(['loggedUser']),
    isShowSuperAdminEmailMesssage() {
      //host admins
      if (this.loggedUser.role === 'Admin') return false

      //super admin
      if (this.loggedUser.role === 'SuperAdmin' && this.isGlobalSettings)
        return false
      else if (
        this.loggedUser.role === 'SuperAdmin' &&
        !this.isGlobalSettings
      ) {
        //regular - not backup
        if (
          this.backupType === 0 &&
          this.organization.emailDefinitions.emailProtocol === 'Default'
        )
          return false
        //backup
        if (
          this.backupType === 1 &&
          this.organization.backupEmailDefinitions.emailProtocol === 'Default'
        )
          return false
        //secondary backup
        if (
          this.backupType === 2 &&
          this.organization.secondBackupEmailDefinitions.emailProtocol === 'Default'
        )
          return false
      }
      return true
    },
    computedIsShowSMTP() {
      //if the user is super admin in regular host
      if (this.loggedUser.role === 'SuperAdmin' && !this.isGlobalSettings)
        return false
      console.log('this.organization: ', this.organization)
      switch (this.backupType) {
        case 0:
          return this.organization.emailDefinitions.emailProtocol === 'SMTP'
        case 1:
          return (
            this.organization.backupEmailDefinitions.emailProtocol === 'SMTP'
          )
        case 2:
          return (
            this.organization.secondBackupEmailDefinitions.emailProtocol ===
            'SMTP'
          )
        default:
          return false
      }
    },

    computedIsShowMsGraph() {
      //if the user is super admin in regular host
      if (this.loggedUser.role === 'SuperAdmin' && !this.isGlobalSettings)
        return false
      switch (this.backupType) {
        case 0:
          return (
            this.organization.emailDefinitions.emailProtocol === 'Microsoft Graph'
          )
        case 1:
          return (
            this.organization.backupEmailDefinitions.emailProtocol ===
            'Microsoft Graph'
          )
        case 2:
          return (
            this.organization.secondBackupEmailDefinitions.emailProtocol ===
            'Microsoft Graph'
          )
        default:
          return false
      }
    },

    computedIsShowTestEmail() {
      switch (this.backupType) {
        case 0:
          return this.organization.emailDefinitions.emailProtocol !== 'Default'
        case 1:
          return (
            this.organization.backupEmailDefinitions.emailProtocol !== 'Default'
          )
        case 2:
          return (
            this.organization.secondBackupEmailDefinitions.emailProtocol !==
            'Default'
          )
        default:
          return false
      }
    },

    computedTitle() {
      switch (this.backupType) {
        case 0:
          return ''
        case 1:
          return 'Backup '
        case 2:
          return 'Secondary Backup '
        default:
          return ''
      }
    }
  },
}
</script>
